import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedSolutionsSection() {
  return <section className="w-full py-24 px-4 bg-brand-bg-alt border-b border-brand-card" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-23">
          <h3 className="text-2xl font-serif font-bold text-brand-text-muted mb-10 text-center uppercase tracking-widest" data-id="element-24">
            The Failed Solutions
          </h3>

          <div className="space-y-6 mb-16" data-id="element-25">
            <div className="flex items-center p-6 bg-brand-bg rounded-lg border border-brand-card opacity-70" data-id="element-26">
              <XCircle className="w-8 h-8 text-red-500 mr-6 flex-shrink-0" data-id="element-27" />
              <p className="text-xl text-brand-text-muted line-through decoration-red-500/50 decoration-2" data-id="element-28">
                Therapists tell you to "open up" and "share your feelings."
              </p>
            </div>

            <div className="flex items-center p-6 bg-brand-bg rounded-lg border border-brand-card opacity-70" data-id="element-29">
              <XCircle className="w-8 h-8 text-red-500 mr-6 flex-shrink-0" data-id="element-30" />
              <p className="text-xl text-brand-text-muted line-through decoration-red-500/50 decoration-2" data-id="element-31">
                Motivational speakers tell you to "get a hobby."
              </p>
            </div>
          </div>

          <div className="text-center relative py-10" data-id="element-32">
            <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-33">
              <div className="w-full border-t border-brand-card" data-id="element-34"></div>
            </div>
            <div className="relative flex justify-center" data-id="element-35">
              <span className="px-6 bg-brand-bg-alt text-brand-text-muted text-sm uppercase tracking-widest" data-id="element-36">
                The Truth
              </span>
            </div>
          </div>

          <div className="text-center mt-8" data-id="element-37">
            <p className="text-xl text-brand-text mb-6" data-id="element-38">
              But hobbies don’t fix the fact that there are now two CEOs in a
              one-office company.
            </p>

            <div className="bg-gradient-to-r from-brand-accent/10 via-brand-accent/20 to-brand-accent/10 p-8 rounded-xl border border-brand-accent/30" data-id="element-39">
              <p className="text-3xl md:text-4xl font-serif font-bold text-white leading-tight" data-id="element-40">
                Communication isn't the problem—
                <br data-id="element-41" />
                <span className="text-brand-accent" data-id="element-42">Logistics is.</span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}